import { IH2HMatch } from "core-integration/src/store/leagues/types";
import { Cell } from "react-aria-components";
import { useTranslation } from "react-i18next";
import { Result } from "../../../../Result";
import { rankCellStyles } from "../../../LeagueType/LeagueTypeTable/leagueTypeTable.css";
import { CupSummaryScore } from "../../../index";

interface CupStatusCellProps {
  cupMatch: IH2HMatch;
  entryId: number;
}

const CupStatusCell = ({ cupMatch, entryId }: CupStatusCellProps) => {
  const { t } = useTranslation("leaguesAndCups");
  const resultChar =
    cupMatch.winner === entryId
      ? t("cupStatusCell.winner", "W")
      : cupMatch.winner
        ? t("cupStatusCell.loser", "L")
        : "";

  return (
    <Cell className={rankCellStyles}>
      {cupMatch.winner ? (
        <Result resultChar={resultChar} />
      ) : (
        <CupSummaryScore match={cupMatch} entryId={entryId} />
      )}
    </Cell>
  );
};

export default CupStatusCell;
